export const tipoLocalConsumo = [
  { value: 0, label: 'ORIGEM' },
  { value: 1, label: 'DESTINO' },
  { value: 2, label: 'OUTROS' },
];
